<template>
  <div
    v-if="uniqueCode && widgetData"
    class="mx-2 my-2"
  >
    <click-to-text-widget-minimized
      v-if="widgetState === 'minimized'"
      :widget-data="widgetData"
      @click="widgetState = 'expanded'"
    />

    <click-to-text-widget-completed
      v-else-if="widgetState === 'completed'"
      :widget-data="widgetData"
      @close="widgetState = 'minimized'"
    />

    <click-to-text-widget-expanded
      v-else
      :widget-data="widgetData"
      @submit="submit"
      @close="widgetState = 'minimized'"
    />
  </div>
</template>

<script lang="ts">
import { getUniqueCode } from '@widgets/shared/compositions/uniqueCode'
import {
  sendWidgetAppearMessage,
  sendWidgetPositionMessage,
  sendWidgetResizeMessage,
} from '@widgets/shared/utils/windowMessages'
import { useClickToTextWidgetState } from '@widgets/click-to-text/compositions/clickToTextWidgetState'
import { useClickToTextForm } from '@widgets/click-to-text/compositions/clickToTextForm'
import ClickToTextWidgetCompleted from '@widgets/click-to-text/components/ClickToTextWidgetCompleted.vue'
import ClickToTextWidgetExpanded from '@widgets/click-to-text/components/ClickToTextWidgetExpanded.vue'
import ClickToTextWidgetMinimized from '@widgets/click-to-text/components/ClickToTextWidgetMinimized.vue'
import { useQuasarIcons } from '@widgets/shared/compositions/quasarIcons'
import clickToTextApiService from '@widgets/click-to-text/services/clickToTextApiService'
import { defineComponent, ref } from '@/composition/vue/compositionApi'
import type { ClickToTextForm } from '@/services/domain/services/forms/clickToText/types'

export default defineComponent({
  components: {
    ClickToTextWidgetExpanded,
    ClickToTextWidgetCompleted,
    ClickToTextWidgetMinimized,
  },
  setup() {
    sendWidgetAppearMessage('fixed')

    useQuasarIcons()

    const uniqueCode = getUniqueCode()

    const widgetData = ref<ClickToTextForm>()
    clickToTextApiService.getSettings(uniqueCode).then((settings) => {
      if (!settings) return
      widgetData.value = settings
      fieldsConfig.name.disabled = !settings.nameVisible
      form.countryCode = settings.defaultCountryId
      sendWidgetPositionMessage(settings.position)
    })

    const { widgetState } = useClickToTextWidgetState((boundaries) => sendWidgetResizeMessage(boundaries))

    const { submit, fieldsConfig, form } = useClickToTextForm(uniqueCode!, widgetState)

    return {
      uniqueCode,
      widgetData,
      widgetState,
      submit,
    }
  },
})
</script>
